module.exports = __webpack_public_path__ + "img/union.40f7c174.png";